import PropTypes from "prop-types";
import React, { Component } from "react";
import { reduxForm, change as formChange } from "redux-form";

import InputGroup from "components/InputGroup";
import Button from "components/Button";
import Input from "components/Input/Input";
import ButtonSelect from "components/ButtonSelect";
import {
  isValidEmail,
} from "helpers/validators";

import {
  categoriesData,
  countriesData,
} from "helpers/supportedCountriesConfig";
import { fetch as router } from "helpers/router";
import { selectCountry, selectCategory } from "../tips/actions";

import "./_style.scss";

const form = "startACampaign";

const fields = [
  "category",
  "country",
  "email",
  "name",
];

const descriptions = {
  country: <p>You need a bank account in this country that we can send funds to</p>,
  category:
  <p>
    Donors can browse by these categories to find your campaign.
    <br />
    {" "}
    Choose the most appropriate
  </p>,
  name: <p>Your name, not your organization’s</p>,
  email: <p>This will be your account login. We won’t share it with third parties</p>,
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Enter out your name";
  }
  if (!values.email) {
    errors.email = "Enter your email address";
  } else if (isValidEmail(values.email) === false) {
    errors.email = "Enter a valid email address";
  }
  if (!values.category) {
    errors.category = "Choose a category";
  }
  if (!values.country) {
    errors.country = "Choose a country";
  }

  return errors;
};

class StartACampaignForm extends Component {
  componentDidMount() {
    const globalConfig = window.startACampaignConfig;
    if (globalConfig && globalConfig.selectedCountry) {
      this.props.onCountryChange({ target: { value: globalConfig.selectedCountry } });
    }
  }

  render() {
    const {
      fields: {
        email,
        name,
        category,
        country,
      },
      valid,
      errors,
      submitting,
      handleSubmit,
      onCountryChange,
      onCategoryChange,
    } = this.props;

    const errorMessage = !valid && (
      <div>
        <span>To get started please complete the form:</span>
        <ul>
          {
            Object.keys(errors).map((errorField, key) => (
              <li key={key}>{errors[errorField]}</li>
            ))
          }
        </ul>
      </div>
    );

    const action = router("api.v2.onboarding.store");

    return (
      <form method="post" action={action} acceptCharset="UTF-8">
        <InputGroup
          label="Country"
          description={descriptions.country}
          inline
        >
          <ButtonSelect
            onChange={onCountryChange}
            buttons={countriesData.buttons}
            defaultOption="Other"
            options={countriesData.options}
            selectedValue={country.value}
          />
        </InputGroup>
        <InputGroup
          label="Category"
          description={descriptions.category}
          inline
        >
          {categoriesData.map((categoryData, key) => (
            <Button
              key={key}
              look="small"
              className="start-a-campaign__category-selector"
              onClick={onCategoryChange}
              isSelected={category.value === categoryData.value}
              value={categoryData.value}
            >
              {categoryData.name}
            </Button>
          ))}
        </InputGroup>
        <InputGroup
          label="Name"
          description={descriptions.name}
          inline
        >
          <Input {...name} placeholder="Your Name" />
        </InputGroup>
        <InputGroup
          label="Email"
          description={descriptions.email}
          inline
        >
          <Input {...email} placeholder="email@example.com" />
        </InputGroup>
        <div className="start-a-campaign__get-started">
          <div className="start-a-campaign__action">
            <Button
              onClick={handleSubmit}
              type="submit"
              look="primary"
              isDisabled={!valid || submitting}
              showTooltip
              errorMessage={errorMessage}
              isLoading={submitting}
              loadingMessage="Setting up your campaign"
            >
              Get Funding ❯
            </Button>
            <p style={{ fontSize: ".8rem", paddingTop: "1rem" }}>
              By starting a campaign, you agree with Chuffed.org&apos;s
              {" "}
              {" "}
              <a href="/terms-conditions" target="_blank">terms and conditions</a>
            </p>
          </div>
        </div>
      </form>
    );
  }
}

StartACampaignForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  valid: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
};

const StartACampaignRedux = reduxForm(
  {
    form,
    fields,
    validate,
  },
  () => ({}),
  (dispatch) => ({
    onCountryChange: (e) => {
      const nextCountry = e.target.value;
      // form action
      dispatch(formChange(form, "country", nextCountry));
      // tips action
      dispatch(selectCountry(nextCountry));
    },
    onCategoryChange: (e) => {
      const nextCategory = e.target.value;
      // form action
      dispatch(formChange(form, "category", nextCategory));
      // tips action
      dispatch(selectCategory(nextCategory));
    },
  }),
)(StartACampaignForm);

export default StartACampaignRedux;
